export const alert = {
  namespaced: true,
  state: {
    type: null,
    message: null,
    loading: false
  },
  actions: {
    success({ commit }, message) {
      commit("success", message);
    },
    error({ commit }, message) {
      commit("error", message);
    },
    clear({ commit }, message) {
      commit("success", message);
    },
    loadingOn({ commit }) {
        commit("loadingOn");
    },
    loadingOff({ commit }) {
        commit("loadingOff");
    }
  },
  mutations: {
    success(state, message) {
      state.type = message;
      state.message = message;
    },
    error(state, message) {
      state.type = "error";
      state.message = message;
    },
    clear(state) {
      state.type = null;
      state.message = null;
    },
    loadingOn(state) {
        state.loading = true;
    },
    loadingOff(state) {
        state.loading = false;
    }
  },
  getters: {
      alert: state => state.alert
  }
};
